<style scoped="scoped" lang="scss">
	.hideFormItem {
		display: none !important;
	}

	.container {
		padding-left: 24px;
		padding-right: 24px;
		overflow: auto;
		min-width: 500px;

		// 隐藏表单项
		.hideFormItem {
			display: none !important;
		}
	}
</style>
<template>
	<div class="container">
		<div>
			<el-tabs v-model="activeName" @tab-click="changeTab">
				<!-- 效率月报 -->
				<el-tab-pane :label="$t('xiaoluyuebao')" name="first">
					<div>
						<efficiency_monthly></efficiency_monthly>
					</div>
				</el-tab-pane>
				<!-- 产量月报 -->
				<el-tab-pane :label="$t('chanliangyuebao')" name="second">
					<div>
						<production_monthly></production_monthly>
					</div>
				</el-tab-pane>
				<!-- 效率明细 -->
				<el-tab-pane :label="$t('xiaolumingxi')" name="three">
					<div>
						<efficiency_details></efficiency_details>
					</div>
				</el-tab-pane>
				<!-- 产量明细 -->
				<el-tab-pane :label="$t('chanliangmingxi')" name="four">
					<div>
						<production_details></production_details>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>
<script type="text/javascript">
	import efficiency_monthly from '@@/pages/web/report/producee_report/efficiency/monthly'
	import production_monthly from '@@/pages/web/report/producee_report/production/monthly'
	import efficiency_details from '@@/pages/web/report/producee_report/efficiency/details'
	import production_details from '@@/pages/web/report/producee_report/production/details'
	export default {
		name: 'web_report_producee_report_list',
		components: {
			efficiency_monthly,
			production_monthly,
			efficiency_details,
			production_details
		},
		data() {
			return {
				activeName: 'first',
			}
		},
		methods:{
		  changeTab(tab) {
		if (tab.name == "three") {
		  this.utils.event_hub.$emit('EFFICENCY_REPORT_RESIZE')
		}
		    if (tab.name == "four") {
		      this.utils.event_hub.$emit('PRODUCTION_REPORT_RESIZE')
		    }
		  }
		}
	}
</script>
